import React, { Component } from "react";
import {
  Button,
  Table,
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import BlockUi from 'react-block-ui';
import Pagination from "react-js-pagination";
import * as checkinConstant from './constants'
import * as checkinAction from './actions'
import DisplayRecordText from "../controls/_DisplayRecordText"
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { currentDate, formatDateTime } from '../../lib/common'
import CheckboxTreeList from "../controls/_CheckboxTreeList";
import { storedb } from '../../views/client/storedb'
class CheckinReport extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      store_id: dbContext.getStoreId(),
      list: [],
      per_page: 20,
      page: 1,
      total_record: 0,
      keyword: '',
      tuNgay: currentDate().startOf('month'),
      denNgay: currentDate(),
      multipleValueNVKD: [],
      treeNvkd: [],
      urlToHugeImageFile: null,
      urlToHugeImageTitle: ''
    };
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  handleDateChange(name, e, value) {
    switch (name) {
      case "tuNgay":
        this.setState({ tuNgay: e });
        break;
      case "denNgay":
        this.setState({ denNgay: e });
        break;
    }
  }
  keyPress = (e) => {
    if (e.keyCode == 13) {
      this.search()
    }
  }
  handleSearchChange = (e, name) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  onHandleChoiceNvkd = (nodesChecked) => {
    var multipleValue = [];
    nodesChecked.forEach(function (item) {
      if (item.value != 0) {
        multipleValue.push(item.value);
      }
    });
    this.setState({ multipleValueNVKD: multipleValue })
  }
  fetchNvkd = () => {
    const { checkinReportNvkdRequest } = this.props
    var requestData = {
      store_id: this.state.store_id
    };
    return checkinReportNvkdRequest(requestData);
  }
  fetchList = () => {
    const { checkinReportRequest } = this.props
    var requestData = {
      keyword: this.state.keyword,
      tuNgay: this.state.tuNgay ? this.state.tuNgay.unix() : '',
      denNgay: this.state.denNgay ? this.state.denNgay.unix() : '',
      nhanVien: this.state.multipleValueNVKD,
      page: this.state.page,
      per_page: this.state.per_page
    };
    return checkinReportRequest(requestData);
  }
  search = () => {
    if (this.props.checkinReport.listRequesting) {
      return false;
    }
    return this.fetchList()
  }
  exportXls = () => {
    const { checkinReportExportXlsRequest } = this.props

    var requestData = {
      keyword: this.state.keyword,
      tuNgay: this.state.tuNgay ? this.state.tuNgay.unix() : '',
      denNgay: this.state.denNgay ? this.state.denNgay.unix() : '',
      nhanVien: this.state.multipleValueNVKD.length > 0 ? this.state.multipleValueNVKD[0] : '',
      page: this.state.page,
      per_page: this.state.per_page
    };
    const dialogSaveFile = (data) => {
      var dataFile = new Blob([data], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExport';
      var fileName = "baocao_checkin.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExport";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
      }
    }
    return checkinReportExportXlsRequest(requestData, dialogSaveFile)
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  viewImageHurge = (e, imgSrc, imgTitle) => {
    e.preventDefault()
    console.log(e, imgSrc, imgTitle)
    this.setState({ urlToHugeImageFile: imgSrc, urlToHugeImageTitle: imgTitle })
  }
  closeViewImageHurge = () => {
    this.setState({
      urlToHugeImageFile: null,
      urlToHugeImageTitle: ''
    });
    this.props.onClose();
  }
  viewLocation = (e, lat, long) => {
    e.preventDefault()
    const url = 'http://maps.google.com/?q=' + lat + ',' + long;
    window.open(url, '_blank');
  }
  componentDidMount() {
    this.fetchNvkd();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.checkinReport.type == checkinConstant.CHECKIN_REPORT_SUCCESS) {
      let { list, item } = nextProps.checkinReport;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        list: list
      });
    } else if (nextProps.checkinReport.type == checkinConstant.CHECKIN_REPORT_NVKD_SUCCESS) {
      let { listNVKD } = nextProps.checkinReport;
      if (listNVKD && listNVKD.length === 1) {
        // neu chi co 1 minh no thì thực hiện set luôn nó
        const NvkdChecked = listNVKD.map((item) => { return { value: item.Id } })
        this.onHandleChoiceNvkd(NvkdChecked)
      };
      this.setState({
        treeNvkd: listNVKD
      });
    }
  }
  render() {
    const {
      checkinReport: {
        isRequesting,
        list
      },
    } = this.props
    const { treeNvkd, urlToHugeImageFile, urlToHugeImageTitle } = this.state
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={isRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm" overflowWhenOpen="inherit" open={true}>
              <Row className="report-control">
                <Col sm="4" className="mb-2 pl-2 pr-2 half-right">
                  <InputGroup size="md">
                    <InputGroupAddon className="d-none d-sm-block" addonType="prepend" autoComplete="off" >Từ khóa</InputGroupAddon>
                    <Input name="keyword"
                      placeholder="Lịch chăm sóc, khách hàng, Địa chỉ"
                      value={this.state.keyword}
                      autoComplete="off"
                      onKeyDown={e => this.keyPress(e)}
                      onChange={e => this.handleSearchChange(e, "keyword")} />
                  </InputGroup>
                </Col>
                <Col md="2" sm="3" xs="6" className="mb-2 pl-2 pr-0 half-left">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Từ:</span>
                    <DatePicker
                      name="tuNgay"
                      placeholder="Từ ngày"
                      selected={this.state.tuNgay}
                      onChange={this.handleDateChange.bind(this, "tuNgay")}
                      required className={"form-control add_date_exs_input"}
                      dateFormat="DD/MM/YYYY" />
                  </InputGroup>
                </Col>
                <Col md="2" sm="3" xs="6" className="mb-2 pr-0 half-right">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Đến:</span>
                    <DatePicker
                      name="denNgay"
                      placeholder="đến ngày"
                      selected={this.state.denNgay}
                      onChange={this.handleDateChange.bind(this, "denNgay")}
                      required className={"form-control add_date_exs_input"}
                      dateFormat="DD/MM/YYYY" />
                  </InputGroup>
                </Col>
                <Col md="4" sm="12" xs="8" className="mb-2 pl-2 pr-2 half-right">
                  <InputGroup size="md">
                    <CheckboxTreeList
                      placeholder={`--Nhân viên KD--`}
                      nodes={treeNvkd}
                      isMultiChoice={false}
                      checked={this.state.multipleValueNVKD}
                      onChoice={e => this.onHandleChoiceNvkd(e)}
                    />
                  </InputGroup>
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
              <Button size="md" color="success" className="pull-left mr-1"
                onClick={(e) => this.search(e)}><i className="fa fa-search"></i> Tìm kiếm</Button>
              <Button size="md" color="primary" className="pull-left mr-1" onClick={this.exportXls}><i className="fa fa-file-excel-o"></i> Xuất excel</Button>
              <div className="clearfix"></div>
            </div>
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="40" className="text-center">#</th>
                    <th scope="col" className="text-left">Thời gian</th>
                    <th scope="col" className="text-left">Nhân viên</th>
                    <th scope="col" className="text-left">Lịch chăm sóc</th>
                    <th scope="col" className="text-left">Khách hàng</th>
                    <th scope="col" className="text-left">Địa chỉ</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-left">{res.NgayTao && formatDateTime(res.NgayTao, 'HH:mm DD/MM/YYYY')}</td>
                        <td className="text-left">{res.TenNhanVien}</td>
                        <td className="text-left">{res.NgayCheckIn}</td>
                        <td className="text-left">{res.MaKhachHang}-{res.TenKhachHang}</td>
                        <td className="text-left"><a className="text-primary font-weigh-bold" onClick={(e) => this.viewLocation(e, res.Latitude, res.Longtitude)}>{res.DiaChi}</a></td>
                        <td className="text-right"><img style={{ cursor: "pointer" }} width="100px" src={res.ImageCheckin} onClick={(e) => this.viewImageHurge(e, res.ImageCheckin, res.TenNhanVien)} /></td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
          {/* hien thi ảnh checkin lên popup */}
          <Modal isOpen={urlToHugeImageFile != null} className="modal-lg">
            <ModalHeader style={{ padding: '0.5rem' }}>{urlToHugeImageTitle}</ModalHeader>
            <ModalBody>
              <img style={{ width: "100%" }} src={urlToHugeImageFile} className="img-fluid" />
            </ModalBody>
            <ModalFooter className="p-1">
              <Button color="danger" className="ml-2" onClick={this.closeViewImageHurge.bind(this)}><i className="fa fa-close"></i>&nbsp;Đóng</Button>
            </ModalFooter>
          </Modal>
        </BlockUi >
      </div >
    )
  }
}
const mapStateToProps = state => ({
  checkinReport: state.checkinReport,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  checkinReportRequest: checkinAction.checkinReportRequest,
  checkinReportNvkdRequest: checkinAction.checkinReportNvkdRequest,
  checkinReportExportXlsRequest: checkinAction.checkinReportExportXlsRequest
})(CheckinReport)
const formed = reduxForm({
  form: 'checkinReport',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/Checkin/CheckinReport.js